/* eslint import/prefer-default-export: "off" */
import type { APIResponse } from '@src/endpoints'
import { PolicyReader } from '@src/endpoints/services/policyReader.service'
import type { GetPoliciesResp } from '@src/endpoints/services/policyReader.service'
import type { GetPoliciesReqEx } from '@src/redux/actions/policies.actions'

export function getPolicyDocuments(
  policies: string[],
  account_ids: string[],
  identity_uri?: string,
  callback?: (res: APIResponse<GetPoliciesResp>) => void
) {
  const params: GetPoliciesReqEx = {
    policies,
    account_ids
  }
  if (identity_uri) {
    params.identity_uri = identity_uri
  }

  PolicyReader.GetPolicies({ params })
    .then(res => res)
    .then(res => {
      if (typeof callback === 'function') {
        callback(res)
      }
    })
    .catch(ex => ex)
}
